import Icon from '../../../../../../../components/Icon'
import Button from "../../../../../../../components/Button";
import trashIcon from "../../../../../../../assets/icons/trash-bold.svg";
import {
  Flex
} from './styles'

const Component = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      options={{
        skin: 'black',
        type: 'outline',
        size: 'md',
      }}
      style={{
        color: "#2d3436",
        height: "40px",
        padding: "0px 12px",
        minWidth: 0,
        flexShrink: 0
      }}
    >
      <Flex style={{ gap: 4 }}>
        <Icon icon={trashIcon} size="24px" color="#2d3436" />
        <span>Eliminar</span>
      </Flex>
    </Button>
  )
}

export default Component